import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganisationDto } from '@careapp-group/ng-sdk-v2-new';

export interface OrganisationSelectDialogData {
  organisations: { [key: string]: OrganisationDto };
  initialSelectedIds: string[];
  disabledIds: string[];
  single?: boolean;
  readOnly?: boolean;
}

@Component({
  selector: 'ca-organisation-list-select-dialog',
  templateUrl: './organisation-list-select-dialog.component.html',
  styleUrls: ['./organisation-list-select-dialog.component.scss'],
})
export class OrganisationListSelectDialogComponent implements OnInit {
  public selectedIds: string[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: OrganisationSelectDialogData
  ) {}

  ngOnInit(): void {
    this.selectedIds = this.data.initialSelectedIds.filter((id) =>
      !(this.data.disabledIds ?? []).includes(id)
    );
  }

  selectOrgs(organisations?: OrganisationDto[]) {
    this.selectedIds = Object.keys(organisations).filter((id) =>
      !(this.data.disabledIds ?? []).includes(id)
    );
  }

  onSelectedIdChange(ids: string[]) {
    this.selectedIds = ids;
  }
}
